import { Link } from 'react-router-dom';
import { Linkedin, Youtube, Mail, Phone, MapPin } from 'lucide-react';
import mainLogoWhite from '../assets/images/home/mainLogoWhite.svg';

export function Footer() {
  return (
    <footer className="bg-gray-950 text-gray-300 py-16 lg:py-24 border-t border-gray-900">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8 mb-16">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <img 
                src={mainLogoWhite} 
                alt="Voxonics" 
                width={122}
                height={65}
                decoding="async"
                className="w-25"
              />
            </Link>
            <p className="text-gray-400 mb-8 max-w-sm leading-relaxed">
            The global telecom licensed platform specializing in Virtual AI Agents, Voice AI and Conversation Intelligence for smarter, data-driven communication.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.linkedin.com/company/voxonics/"
                aria-label="Voxonics on LinkedIn"
                title="LinkedIn"
                className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400/70 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-950"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="https://www.youtube.com/@Voxonics"
                aria-label="Voxonics on YouTube"
                title="YouTube"
                className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400/70 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-950"
              >
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-6">Platform</h3>
            <ul className="flex flex-col gap-4">
              <li><Link to="/platform/voip-services" className="text-gray-400 hover:text-white transition-colors">VoIP Services</Link></li>
              <li><Link to="/platform/cloud-pbx" className="text-gray-400 hover:text-white transition-colors">Cloud PBX Platform</Link></li>
              <li><Link to="/platform/virtual-agents" className="text-gray-400 hover:text-white transition-colors">Voice Virtual AI Agents</Link></li>
              <li><Link to="/platform/ai-routing" className="text-gray-400 hover:text-white transition-colors">Smart AI Routing</Link></li>
              <li><Link to="/platform/predictive-dialer" className="text-gray-400 hover:text-white transition-colors">Auto Dialer</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-6">Company</h3>
            <ul className="flex flex-col gap-4">
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/solutions" className="text-gray-400 hover:text-white transition-colors">Solutions</Link></li>
              <li><Link to="/integrations" className="text-gray-400 hover:text-white transition-colors">Integrations</Link></li>
              <li><Link to="/pricing" className="text-gray-400 hover:text-white transition-colors">Pricing</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-6">Contact</h3>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-gray-500 shrink-0 mt-0.5" />
                <span className="text-gray-400">1054 Honved 8,<br />Budapest, Hungary</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-gray-500 shrink-0 mt-1" />
                <div className="flex flex-col gap-1">
                  <span className="text-gray-400">🇭🇺 +36 (1) 9876767</span>
                  <span className="text-gray-400">🇬🇧 +44 (33) 00272728</span>
                  <span className="text-gray-400">🇧🇷 +55 (61) 40404260</span>
                  <span className="text-gray-400">🇺🇸 +1 (888) 8860480</span>
                  <Link to="/contact?topic=api" className="text-indigo-400 hover:text-indigo-300 text-xs font-bold mt-2 transition-colors">Didn't find yours?</Link>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-gray-500 shrink-0" />
                <span className="text-gray-400">Office@voxonics.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-900 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Voxonics. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm">
            <Link to="/privacy" className="text-gray-500 hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-gray-500 hover:text-white transition-colors">Terms of Service</Link>
            <Link to="/security" className="text-gray-500 hover:text-white transition-colors">Security</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
